<div *ngIf="storages.length > 0">
  <h3>Speicher</h3>
  <section *ngFor="let storage of storages; first as isFirst; last as isLast">
    <h4>
      <span *ngIf="storage.count">{{ storage.count.toString() }} x</span>
      {{ storage.manufacturer }}
      <span *ngIf="storage.manufacturer && storage.deviceTypeName">-</span>
      {{ storage.deviceTypeName }}
    </h4>
    <div>
      <app-value-with-label
        *ngIf="storage.usableCapacity"
        [label]="'Nutzbare Speicherkapazität:'"
        [value]="(storage.usableCapacity | number : undefined : 'de-DE') + ' kWh'"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="storage.couplingType"
        [label]="'Art der Kopplung:'"
        [value]="storage.couplingType == 'AC' ? 'AC' : 'DC'"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="storage.acCoupling"
        [label]="'AC-gekoppelt:'"
        [value]="storage.acCoupling ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="storage.dcCoupling"
        [label]="'DC-gekoppelt:'"
        [value]="storage.dcCoupling ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="storage.networkReplaceService"
        [label]="'Netzersatzbetrieb gemäß VDE-AR-E 2510-2:'"
        [value]="storage.networkReplaceService ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="storage.alternatingCurrent"
        [label]="'Wechselstrom:'"
        [value]="storage.alternatingCurrent ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="storage.alternatingCurrent && storage.phases"
        [breakLine]="true"
        [label]="'Anzahl der Phasen:'"
        [value]="storage.phases | phasesTypePipe"></app-value-with-label>
    </div>
    <div *ngIf="storage.disconnectionByIsolatedOperation">
      Allpolige Trennung vom öffentlichen Netz bei Inselbetrieb.
    </div>
    <div *ngIf="storage.networkAndDeviceProtection">NA-Schutz nach VDE-AR-N 4105 vorhanden.</div>
  </section>
  <section>
    <app-value-with-label
      [label]="'<b>Gesamte nutzbare Speicherkapazität der Speicher:</b>'"
      [value]="
        '<b>' +
        (storages.length | totalPowerStoragePipe : storages | number : undefined : 'de-DE') +
        ' kWh</b>'
      "></app-value-with-label>
  </section>
</div>
